export default __webpack_public_path__ + "b91c3d07a32cfa30e7f0ec3a83b0657c.svg";